import { configureStore } from '@reduxjs/toolkit';
import formDataReducer from '../features/formDataSlice';

const store = configureStore({
    reducer: {
        formData: formDataReducer
    },
    devTools: process.env.NODE_ENV === 'development'
  })

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store